import { APP } from '../../redux/constants/app.constants';

export const PRESENTATION_PAGE_DIALOG = `${APP}/PRESENTATION_PAGE_DIALOG`;

export const GET_PRESENTATION_PAGE = `${PRESENTATION_PAGE_DIALOG}/GET_PRESENTATION_PAGE`;
export const HIDE_PRESENTATION_PAGE = `${PRESENTATION_PAGE_DIALOG}/HIDE_PRESENTATION_PAGE`;
export const URL_CHANGED = `${PRESENTATION_PAGE_DIALOG}/URL_CHANGED`;